import React from 'react';
import Stopper from '@/errorManagement/errorPages/default';
import OneTrust from '@/bit/components/components.one-trust-x';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import AppController from '@/components/appController';
import RouteHandler from '@/bit/core/core.route-handler';
import { reportJSError } from '@/utils/common';
import { wrapper } from '@/store';
import '@/styles/globals.css';
import '@/styles/globalVars.scss';

 /* [STYLES] begins */ 
 import '@/styles/globals.scss'; 
 import '@/styles/grid.scss'; 
 import '@/styles/colors.scss'; 
 import '@/styles/fonts.scss';
 
 /* [STYLES] ends */ 

function App({ Component, pageProps }) {
  const { Modal } = useSelector((state) => state.modals);
  const context = useSelector((state) => state.main.context);
  const logError = (jsError) => {
    try {
      reportJSError(jsError, 'errorBoundary', 'pages/_app', context);
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <ErrorBoundary FallbackComponent={Stopper} onError={logError}>
      <RouteHandler />
      <AppController {...pageProps}>
        <Component {...pageProps} />
      </AppController>
      {Modal && Modal}
      <OneTrust />
    </ErrorBoundary>
  );
}

export default wrapper.withRedux(App);
